<template>
  <div class="row">
    <div class="col">
      <div
        :class="[
          'card',
          'card-border-color',
          'card-border-color-primary',
          'card-table',
          'be-loading',
          { 'be-loading-active': isBusy },
        ]"
      >
        <div class="card-header d-flex justify-content-between">
          <p class="card-title">{{ group.name }} (Group)</p>
          <div class="btn-group" role="group" aria-label="Basic example">
            <button
                    v-if="hasPermission('Distributor_Create')"
              class="btn btn-primary btn-rounded btn-space"
              @click="addDistributor"
            >
              <i class="icon icon-left mdi mdi-plus text-white"></i>
              Add Distributor
            </button>

            <button
              class="btn btn-success btn-rounded btn-space"
              @click="goBack"
            >
              <i class="mdi icon mdi-backburger text-white"></i>
              Back
            </button>
          </div>
        </div>
        <div class="card-body">
          <div
            class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer"
          >
            <div class="row be-datatable-body">
              <div class="col-sm-12 table-responsive">
                <table class="table table-fw-widget dataTable no-footer">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Created</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="d in distributors" :key="d.id">
                      <td>{{ d.memberName }}</td>
                      <td>{{ formatDate(d.joined) }}</td>
                      <td>
                        <div class="d-flex">
                          <router-link
                            class="
                              btn btn-primary btn-sm btn-rounded btn-space
                              mr-1
                            "
                            :to="{
                              path: `/manufacturer-distributors/${d.memberId}`,
                            }"
                          >
                            View
                          </router-link>
                          <DeleteAssociation
                                             v-if="hasPermission('Group_Remove_Members')"
                            :id="d.memberId"
                            @onComplete="onActionComplete"
                          />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row be-datatable-footer">
              <div class="col-sm-5">
                <div class="dataTables_info">
                  {{ count }} Member{{ count != 1 ? "s" : "" }}
                </div>
              </div>
              <div class="col-sm-7">
                <div class="dataTables_paginate paging_simple_numbers">
                  <ul class="pagination">
                    <li
                      :class="[
                        'paginate_button',
                        'page-item',
                        'previous',
                        { disabled: !hasPrev },
                      ]"
                    >
                      <a href="#" class="page-link" @click.prevent="prev"
                        >Previous</a
                      >
                    </li>
                    <li
                      :class="[
                        'paginate_button',
                        'page-item',
                        'previous',
                        { disabled: !hasNext },
                      ]"
                    >
                      <a href="#" class="page-link" @click.prevent="next"
                        >Next</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddGroupDistributor
      :groupId="groupId"
      @hide="hideModal"
      @onComplete="onComplete"
    />
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import AddGroupDistributor from "../../components/Group/DistributorAssociation/AddGroupDistributor.vue";
    import DeleteAssociation from "../../components/Group/DistributorAssociation/DeleteAssociation";
    import SystemPermissions from "@/permissions";

    export default {
        mixins: [SystemPermissions.Mixin],
  name: "DistributorAssociation",
  components: { AddGroupDistributor, DeleteAssociation },

  data() {
    return {
      isBusy: false,
      isBusyModal: false,
      groupId: "",
      group: {},
      distributors: [],
      count: 0,
      pageNumber: 0,
      pageSize: 10,
      hasNext: false,
      hasPrev: false,
      name: "",
    };
  },

  computed: {
    user: function () {
      return this.$store.state.currentUser;
    },
  },

        created() {
            if (!this.hasPermission("Group_View_Members")) {
                this.$router.push("/restricted");
            }
    this.groupId = this.$route.params.id;
    this.getGroup();
    this.getDistributors();
  },

  methods: {
    async getGroup() {
      this.isBusy = true;

      try {
        const response = await this.$http.get(
          "/Groups/getById/" + this.groupId
        );
        if (response.ok) this.group = response.body;
        this.isBusy = false;
      } catch (error) {
        this.isBusy = false;
      }
    },

    addDistributor() {
      $("#mod-add-distributor").modal("show");
    },

    filter() {
      $("#mod-da-filter").modal("show");
    },

    async performFiltering(filteringOptions) {
      this.name = filteringOptions.name;

      this.getDistributors();
      $("#mod-da-filter").modal("hide");
    },

    hideModal() {
      $("#mod-add-distributor").modal("hide");
    },

    onComplete() {
      this.hideModal();
      this.getDistributors();
    },

    onActionComplete() {
      this.getDistributors();
    },

    async getDistributors() {
      try {
        this.isBusyModal = true;
        this.isBusy = true;

        const response = await this.$http.get(
          "/Groups/getMembers/" +
            this.groupId +
            "/Distributor" +
            "?PageNumber=" +
            this.pageNumber +
            "&PageSize=" +
            this.pageSize
        );

        if (response.ok) {
          this.distributors = response.body.data;
          this.pageNumber = response.body.pageNumber;
          this.pageSize = response.body.pageSize;
          this.count = response.body.count;
          this.hasPrev = response.body.hasPrev;
          this.hasNext = response.body.hasNext;
        }
      } catch (error) {
        this.isBusyModal = true;
        this.isBusy = false;
      }
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },

    formatDate(date) {
      if (date) return moment(date).format("lll");
      else return "";
    },

    prev() {
      this.pageNumber -= 1;
      this.getDistributors();
    },

    next() {
      this.pageNumber += 1;
      this.getDistributors();
    },
  },
};
</script>
